import { Route, Routes } from 'react-router-dom';
import ExampleComponent from './components/ExampleComponent';
import QsightNavbar from './components/QsightNavbar';
import { Outlet } from 'react-router-dom';
import StandardReportLayout from './components/shared/Layouts/StandardReportLayout/StandardReportLayout';
import MetricCardDemo from './components/POCs/MetricCardDemo/MetricCardDemo';
import { ReportProvider } from './components/shared/context/ReportProvider';
import PieChartComponentDemo from './components/PieChartDemo/PieChartComponentDemo';
import NavigationPanelDemo from './components/NavigationPanelDemo/NavigationPanelDemo';
import HorizontalStackedBarChartDemo from './components/StackBarDemo/QSightHorizontalStackedBarChartDemo';

const ReportRoutes = [
  <Route key={1} path='/' element={<Outlet />} >,
    <Route key={4} path='metricCardDemo' element={<MetricCardDemo />} />
    <Route key={5} path='exampleReport' element={<ExampleComponent />} />,
    <Route key={6} path='report/:reportId/:view?' element={<StandardReportLayout />} />
    <Route key={7} path='pieChart' element={<PieChartComponentDemo />} />
    <Route key={8} path='navigationPanel' element={<NavigationPanelDemo />} />
    <Route key={9} path='horizontalstackbarchart' element={<HorizontalStackedBarChartDemo />} />
  </Route>
];

const ReportRoutesWithoutHeader = () => {
  return <ReportProvider><Routes>{ReportRoutes.map(reportRoute => reportRoute)}</Routes></ReportProvider>;
};

const ReportRoutesWithHeader = () => {
  return (
    <ReportProvider>
      <Routes>
        <Route path='/' element={<QsightNavbar />}>
          {ReportRoutes.map(reportRoute => reportRoute)}
        </Route>
      </Routes>
    </ReportProvider>
  );
};

export { ReportRoutesWithHeader, ReportRoutesWithoutHeader };
